import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
    PERMISSION_VACANCIES_WRITE
  } from '../../constants'
import StatusBadge from '../common/helpers/StatusBadge'
import ActivateOrEditVacancyPopup from './helpers/ActivateOrEditVacancyPopup'
import ConfirmRequestPopup from '../common/helpers/ConfirmRequestPopup'
import {clearVacancy} from '../../actions/pages/vacancy-page'
import {pushVacancy} from '../common/functions/push'
import PieChartPanel from '../common/statistics/PieChartPanel'
import AreaChartPanel from '../common/statistics/AreaChartPanel'
import ProtectedElement from '../common/helpers/ProtectedElement'
import WithAjax from '../common/helpers/WithAjax'
import Alert from '../../ui-elements/alerts/Alert'

class VacancyOverview extends Component {
  constructor(){
    super();
    this.onPush = this.onPush.bind(this);
    this.fetchProductionVacanciesData = this.fetchProductionVacanciesData.bind(this)
    this.state = {status: ''}
  }

  componentDidMount(){
    if (this.props.overview === null){
        this.fetchProductionVacanciesData();
    }
  }


  fetchProductionVacanciesData(){
    let url = 'vacancies/' + this.props.vacancyId;

    this.props.ajax.get(url, true, (data) => {
      this.setState({status: data.Status});
    });
  }

  onPush(vacancyId){
    pushVacancy(vacancyId, this.props.ajax.put, this.fetchProductionVacanciesData, this);
  }
  render() {
    if (this.props.overview === null) {
      return (<div />)
    }
    let overviewData = this.props.overview;

    let status = (<StatusBadge status={this.state.status.toLowerCase()} statusLabel={this.state.status} />)

    let manageBtn = (
      <ProtectedElement permission={PERMISSION_VACANCIES_WRITE}>
        <div className="row">
          <div className="col text-right">
            {this.state.status === 'Draft' &&
              <a className="btn btn-rounded btn-primary text-white" role="button" onClick={() =>this.onPush(this.props.vacancyId)}>Push</a>
            }
            <ActivateOrEditVacancyPopup vacancyId={this.props.vacancyId} profileType={overviewData.ProfileType} />
            {this.props.overview.Status === 'Active' &&
              <ConfirmRequestPopup
                url={'vacancies/' + this.props.vacancyId + '/close'}
                btnLabel="Close"
                confirmationQuestion="Are you sure you want to close this offer and make it not visible to the talents?"
                successMessage="The vacancy was closed."
                onSuccess={() => {this.props.clearVacancy()}} />
            }
            {this.props.overview.Status === 'Closed' && this.props.overview.ProductionStatus === 'Active' &&
              <ConfirmRequestPopup
                url={'vacancies/' + this.props.overview.Id + '/reopen'}
                btnLabel="Reopen"
                successMessage="The vacancy was re-opened."
                onSuccess={() => { this.props.clearVacancy() }} />
            }
          </div>
        </div>
      </ProtectedElement>
    )

    return (
      <div>
        {this.state.errorMsg &&
          <div className="col-md-12">
            <Alert className="alert alert-danger alert-outline">
              {this.state.errorMsg}
            </Alert>
          </div>
        }
        {manageBtn}
        <div className="row">
          <div className="col-md-6 widget">
            <div className="title">Overview</div>
            <div className="row">
              <div className="col">
                <div className="row">
                  <div className="col-4">Production title:</div>
                  <div className="col-8"><a href={'/productions/' + overviewData.ProductionId + '/overview'}>{overviewData.ProductionTitle}</a></div>
                </div>
                <div className="row">
                  <div className="col-4">Description:</div>
                  <div className="col-8">{overviewData.Description}</div>
                </div>
                <div className="row">
                  <div className="col-4">Status:</div>
                  <div className="col-8">{status}</div>
                </div>
                <div className="row">
                  <div className="col-4">Deadline:</div>
                  <div className="col-8">{overviewData.DeadlineAsString} {overviewData.DeadlineDaysLeft ? '(' + overviewData.DeadlineDaysLeft + ')' : 'Not specified'}</div>
                </div>
                <div className="row">
                  <div className="col-4">Facility:</div>
                  <div className="col-8">{overviewData.Facility}</div>
                </div>
                <div className="row">
                  <div className="col-4">Notes:</div>
                  <div className="col-8">{overviewData.AdditionalNotes}</div>
                </div>
                <div className="row">
                  <div className="col-4">Schedule:</div>
                  <div className="col-8">
                    {overviewData.Periods.map((period, i) => (
                      <div key={i}>{period}</div>
                    ))}
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">Actual work:</div>
                  <div className="col-8">{overviewData.ActualWorkAmount}</div>
                </div>
                <div className="row">
                  <div className="col-4">Offered work:</div>
                  <div className="col-8">{overviewData.WorkAmount ? overviewData.WorkAmount : 'Not set yet'}</div>
                </div>
                <div className="row">
                  <div className="col-4">Rate:</div>
                  <div className="col-8">{overviewData.RateFormatted ? overviewData.RateFormatted : 'Not set yet'}</div>
                </div>
                <div className="row">
                  <div className="col-4">Budget:</div>
                  <div className="col-8">{overviewData.BudgetAmountFormatted ? overviewData.BudgetAmountFormatted : 'Not set yet'}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 widget">
            <div>
                <PieChartPanel title="Candidates" data={overviewData.StatisticsOfCandidates} colors={["blue", "darkblue", "green", "indigo", "purple"]} />
            </div>
            <div>
                <AreaChartPanel title="Views" data={overviewData.StatisticsOfViews} />
            </div>
          </div>
        </div>
        {manageBtn}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  overview: state.vacancyPage.overview
})
const mapDispatchToProps = dispatch => ({
  clearVacancy() { dispatch(clearVacancy()) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(VacancyOverview))
